<template>
  <div>
    <h1>About MyCrew</h1>
    <h2>Intro</h2>
    <p>MyCrew is a web application that helps you organize your team and manage your shifts.</p>
    <p>It is built with
      <a href="https://www.djangoproject.com/" class="link-dark">Django</a>,
      <a href="https://www.django-rest-framework.org/" class="link-dark">Django Rest Framework</a> and
      <a href="https://vuejs.org/" class="link-dark">Vue.js</a>.
    </p>
    <h2>Versions</h2>
    <h3>v3.10 - 01/07l/2025</h3>
    <ul>
      <li>Introduce shift export ordered by first- and lastname (Weezevent style)</li>
    </ul>
    <h3>v3.9 - 07/06/2025</h3>
    <ul>
      <li>Introduce team lead handling</li>
    </ul>
    <h3>v3.8 - 24/05/2025</h3>
    <ul>
      <li>Introduce handling of goodies</li>
    </ul>
    <h3>v3.7.1 - 23/05/2025</h3>
    <ul>
      <li>Fix bug in the user details page, where the user shifts where often empty</li>
    </ul>
    <h3>v3.7 - 13/03/2025</h3>
    <ul>
      <li>Disable "Confirm shift" button if shift has no more available places</li>
      <li>Provide first export with list of all shifts</li>
    </ul>
    <h3>v3.6 - 21/03/2025</h3>
    <ul>
      <li>Introduce "cool down period" and "max event work hours" fields to the Organisation model</li>
      <li>Both fields only configurable by the super admin</li>
    </ul>
    <h3>v3.5 - 07/03/2025</h3>
    <ul>
      <li>Provide "Create user shift" functionality for admin user</li>
    </ul>
    <h3>v3.4 - 03/03/2025</h3>
    <ul>
      <li>Show roles and favourite co-workers in user admin page</li>
      <li>Show user's shifts wit action buttons on user admin page</li>
    </ul>
    <h3>v3.3 - 02/03/2025</h3>
    <ul>
      <li>Order the shift overview by score and number of shifts</li>
      <li>Allow edit of first name and last name on the user's details page</li>
    </ul>
    <h3>v3.2 - 28/02/2025</h3>
    <ul>
      <li>Add button to make password visible during registration</li>
      <li>Allow to specify "Favourite co-workers" on the account page</li>
      <li>Show alert if user did not yet specify preferred co-workers</li>
      <li>Provide "No preferred co-workers" switch on the account page</li>
      <li>Improve validation of maximum reserved hours per event (allow one "very long" shift per event)</li>
      <li>Fixed "Delete requested shift" functionality (Resulted in "404 - Not found" error)</li>

    </ul>
    <h3>v3.1 - 26/02/2025</h3>
    <ul>
      <li>Add about page with version history</li>
      <li>Limit access to about page to users that are admin of an organisation</li>
      <li>Show warning on home page when user has not yet selected one or more organisation roles</li>
    </ul>


  </div>
</template>


<script>
import {useAuthStore} from "@/store/auth";
import {onMounted, ref} from "vue";
// import {useRouter} from "vue-router";

export default {
  name: 'AboutPage',
  setup() {
    const authStore = useAuthStore()
    const user = ref({})
    // const router = useRouter();

    onMounted(
        async () => {
          await authStore.fetchUser()
          user.value = authStore.user
        }
    );

    return {
      user,
    }
  },
  beforeRouteEnter(to, from, next) {
    // If the user is not an admin of an organisation, redirect to the home page
    const authStore = useAuthStore();
    if (!authStore.user || authStore.user.admin_organisations.length === 0) {
      next('/');
    } else {
      next();
    }
  },


}
</script>





